import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettlementHaltedDialogComponentData, SettlementHaltedDialogResponse } from 'src/app/components/aftale/models';
import { G4AfregningerHaltedActionEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/g-4-afregninger-halted-action-enum';

@Component({
    selector: 'app-settlement-halted-dialog',
    templateUrl: './settlement-halted-dialog.component.html',
    styleUrls: ['./settlement-halted-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementHaltedDialogComponent {
  form: UntypedFormGroup;
  settlementId: number;
  errorTextG4: string;
  isCreditnote: boolean;
  creditnoteBilagsnr?: number;
  creditnoteOpkraevningDate?: Date;
  agreementNo?: number;
  serviceorderNo?: number;
  amountExclVat?: number;
  amountInclVat?: number;
  minDate: Date;
  maxDate: Date;

  get accept() {
    return this.form.get('accept');
  }
  get returnBilagsnr() {
    return this.form.get('returnBilagsnr');
  }
  get returnOpkraevningDate() {
    return this.form.get('returnOpkraevningDate');
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<SettlementHaltedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SettlementHaltedDialogComponentData,
  ) {
    this.settlementId = data.settlementId;
    this.errorTextG4 = data.errorTextG4;
    this.isCreditnote = data.isCreditnote;
    this.creditnoteBilagsnr = data.creditnoteBilagsnr;
    this.creditnoteOpkraevningDate = data.creditnoteOpkraevningDate;
    this.agreementNo = data.agreementNo;
    this.serviceorderNo = data.serviceorderNo;
    this.amountExclVat = data.amountExclVat;
    this.amountInclVat = data.amountInclVat;
    this.minDate = this.data.creditnoteOpkraevningDate;
    this.maxDate = new Date();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      accept: [false],
      returnBilagsnr: [this.creditnoteBilagsnr],
      returnOpkraevningDate: [this.creditnoteOpkraevningDate],
    });

    if (this.isCreditnote) {
      this.accept.setValidators([Validators.requiredTrue]);
      this.returnBilagsnr.setValidators([
        Validators.required,
        Validators.maxLength(10),
        Validators.minLength(10),
        Validators.pattern('[0-9]*'),
      ]);
      this.returnOpkraevningDate.setValidators([Validators.required]);
    }
  }

  cancel() {
    const result: SettlementHaltedDialogResponse = {
      settlementId: this.settlementId,
      g4AfregningerHaltedActionEnum: G4AfregningerHaltedActionEnum.Cancel,
    };
    this.dialogRef.close(result);
  }

  retry() {
    const result: SettlementHaltedDialogResponse = {
      settlementId: this.settlementId,
      g4AfregningerHaltedActionEnum: G4AfregningerHaltedActionEnum.Retry,
    };
    this.dialogRef.close(result);
  }

  finish_up() {
    const result: SettlementHaltedDialogResponse = {
      settlementId: this.settlementId,
      g4AfregningerHaltedActionEnum: G4AfregningerHaltedActionEnum.FinishUp,
      creditnoteBilagsnr: this.returnBilagsnr.value,
      creditnoteOpkraevningDate: this.returnOpkraevningDate.value,
    };
    this.dialogRef.close(result);
  }
}
